import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import Carousel from 'nuka-carousel';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { imgixUrl } from 'settings';

/**
 * @typedef {object} RelatedFact
 * @property {number} id - The fact id
 * @property {string} description - The fact description
 */

/**
 * @typedef {object} FastFactsProps
 * @property {number | string} appId - The app id
 * @property {string} image - The image name
 * @property {string} imageCredits - The image credits
 * @property {RelatedFact[]} relatedFacts - The related facts that will be displayed in the carousel.
 */

/**
 * A slider/carousel component for rendering facts from and within specific training pages.
 *
 * @param {FastFactsProps} param0 Props for the facts component
 * @returns {JSX.Element} Facts component
 */
const Facts = ({ appId, image = '', imageCredits = '', relatedFacts = [] }) => {
  if (relatedFacts.length === 0) {
    return null;
  }

  return (
    <div>
      <hr />
      <h4 className="factsTitle">{i18n.translate('facts.title')}</h4>

      <div className="factTop">
        <div className="leftFact">
          <img src={`${imgixUrl}${appId}/${image}?quality=70&fm=jpg`} alt={imageCredits} width={233} height={280} />
        </div>
        <div className="rightFact">
          <Carousel
            autoplayInterval={15000}
            autoplay
            wrapAround
            pauseOnHover
            renderCenterLeftControls={({ previousSlide }) => (
              <button onClick={previousSlide} type="button">
                <FontAwesomeIcon icon={['fas', 'angle-left']} />
              </button>
            )}
            renderCenterRightControls={({ nextSlide }) => (
              <button onClick={nextSlide} type="button">
                <FontAwesomeIcon icon={['fas', 'angle-right']} />
              </button>
            )}
          >
            {relatedFacts.map((fact) => {
              const { id, description } = fact;
              return (
                <div key={id} className="slide">
                  <p className="fact__description">{description}</p>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Facts;

Facts.propTypes = {
  appId: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  relatedFacts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
  imageCredits: PropTypes.string,
};
